var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#006699"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3989 28.1076V17.3024H11.8106V28.1076H15.3993H15.3989ZM13.6055 15.8274C14.8566 15.8274 15.6354 14.9977 15.6354 13.9608C15.612 12.9003 14.8566 12.0938 13.6293 12.0938C12.4012 12.0938 11.5991 12.9003 11.5991 13.9607C11.5991 14.9976 12.3777 15.8273 13.582 15.8273H13.6052L13.6055 15.8274ZM17.3851 28.1076H20.9731V22.0742C20.9731 21.7517 20.9965 21.4283 21.0913 21.198C21.3505 20.5525 21.9409 19.8843 22.9324 19.8843C24.2305 19.8843 24.7501 20.8751 24.7501 22.3278V28.1076H28.338V21.9123C28.338 18.5935 26.568 17.0491 24.2073 17.0491C22.2718 17.0491 21.4217 18.1319 20.9495 18.8693H20.9733V17.3028H17.3853C17.4321 18.3165 17.385 28.108 17.385 28.108L17.3851 28.1076Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.229f68a2b9718d78d972fbd30fcb57ab.svg";
export { ForwardRef as ReactComponent };